import { beginRound } from "./appliers";
import type {
  InitGameOptions,
  ShowMeTheCoinPlayer,
  ShowMeTheCoinPlayerId,
  ShowMeTheCoinState,
} from "./types";
import {
  INITIAL_COIN_INVENTORY,
  SHOW_ME_THE_COIN_PLAYERS,
  SHOW_ME_THE_COIN_START_CHIPS,
} from "./types";

function createPlayer(playerId: ShowMeTheCoinPlayerId): ShowMeTheCoinPlayer {
  return { playerId, label: playerId === "p1" ? "선" : "후" };
}

function freshInventory() {
  return { ...INITIAL_COIN_INVENTORY };
}

export function initGame(options: InitGameOptions = {}): ShowMeTheCoinState {
  const firstLead = options.firstLeadPlayerId ?? "p1";
  if (!SHOW_ME_THE_COIN_PLAYERS.includes(firstLead)) {
    throw new Error("First lead player must be p1 or p2");
  }

  const base: ShowMeTheCoinState = {
    gameId:
      options.gameId ??
      `show-me-the-coin-${SHOW_ME_THE_COIN_PLAYERS.join("-")}`,
    players: SHOW_ME_THE_COIN_PLAYERS.map(createPlayer),
    phase: "submit-lead",
    round: 0,
    leadPlayerId: firstLead,
    currentPlayerId: firstLead,
    inventory: { p1: freshInventory(), p2: freshInventory() },
    chips: {
      p1: SHOW_ME_THE_COIN_START_CHIPS,
      p2: SHOW_ME_THE_COIN_START_CHIPS,
    },
    submission: { p1: null, p2: null },
    pot: 0,
    contributed: { p1: 0, p2: 0 },
    raisesUsed: 0,
    lastAggressorId: null,
    lastRound: null,
    winnerId: null,
    lastAction: null,
    moveNumber: 0,
  };

  // Pay the first round's antes and open the lead submission.
  return beginRound(base);
}
